import {ConfigModel} from 'app/models/CommonModels'
import axios, {AxiosResponse} from 'axios'
import {toAbsoluteUrl} from '../../_metronic/helpers'

const CONFIG_URL = `/data/Config.json`

const AUTH_API_URL = process.env.REACT_APP_AUTH_API_URL
export const MENU_CONTROLLER_URL = `${AUTH_API_URL}/Menu`

export const GetLocalConfig = (): Promise<ConfigModel> => {
  return axios(toAbsoluteUrl(CONFIG_URL)).then((response: AxiosResponse<ConfigModel>) => response.data)
}

export function GetCustomMenu() {
  return axios.get<any>(`${MENU_CONTROLLER_URL}`)
}
